import ContactUs from './ContactUs'
import Map from './Map'

import { useEffect } from 'react';
var scroll = require('scroll')
var page = require('scroll-doc')()
var ease = require('ease-component')

const Contact = ({configs}) => {
    useEffect(() => {
        scroll.top(page, 0)
    }, [])

    return (
        <div className='overflow-hidden'>
            <ContactUs configs={configs} />
            <Map />
        </div>
    )
}
export default Contact